import { connect } from 'react-redux'
import BeforeYouScheduleConnector from '../SchedulingModal/BeforeYouSchedule'
import PreviousPatientCardio from './PreviousPatientCardio.jsx'
import BeforeYouScheduleOBGYNConnector from '../SchedulingModal/OBGYN/BeforeYouScheduleOBGYNConnector.jsx'
import PreviousPatientOBGYN from './PreviousPatientOBGYN.jsx';
import ContinueToSchedulingConnector from '../SchedulingModal/ContinueToScheduling/ContinueToSchedulingConnector.jsx';

const mapStateToProps = state => {
  return {
    doctorUrl: state.schedulingModal.doctorUrl,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hideFunction: () => {
    dispatch({ type: 'HIDE_SCHEDULING_MODAL' });
  },
  continueButtonFunction: () => {
    dispatch({ type: 'SHOW_CONTENT', value: ContinueToSchedulingConnector });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviousPatientOBGYN);
